
const SuccessStories = () => {
  return (
    <div className="pt-20">
      <section className="py-16 bg-gradient-to-r from-blue-50 to-indigo-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">
            Customer Success Stories
          </h1>
          <p className="text-lg text-gray-600 text-center mb-12">
            Discover how our solutions have transformed businesses across the hospitality industry
          </p>
          
          {/* Placeholder for success stories - to be populated with real content */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold mb-4">Coming Soon</h3>
              <p className="text-gray-600">
                We're collecting amazing success stories from our customers. Check back soon!
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SuccessStories;
